import { Outlet, Route, Routes } from 'react-router-dom';
import ErrorPage from './pages/ErrorPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SignInPage from './pages/SignInPage';
import TermsConditionPage from './pages/TermsConditionPage';
import MasterLayout from './masterLayout/MasterLayout';
import ValidateAccount from './pages/ValidateAccount';
import AuthRedirect from './masterLayout/AuthRedirect';
import ProtectedApp from './masterLayout/ProtectedApp';

import ViewProfilePage from './pages/ViewProfilePage'; 
import UsersListPage from './pages/UsersListPage'; 
import UsersPage from './pages/UsersPage'; 
import ClientesListPage from './pages/ClientesListPage';
import ClientesPage from './pages/ClientesPage';
import ProdutosListPage from './pages/ProdutosListPage';
import ProdutosPage from './pages/PordutosPage';
import RelatorioPage from './pages/RelatorioPage';
import PedidosPage from './pages/PedidosPage';
import PedidosListPage from './pages/PedidosListPage';
import DashboardPage from './pages/Dashboard';
//teste
function App() {
    return (
        <>
            <Routes>
                <Route path="" element={<SignInPage />} />
                {/* <Route path="admin/auth" element={<SignInAdminPage />} /> */}
                <Route path="auth" element={<AuthRedirect />} />
                <Route exact path="recuperar-senha" element={<ForgotPasswordPage />} />

                <Route element={<ProtectedApp />}>
                    <Route path="validar-conta" element={<ValidateAccount />} />
                    <Route element={<MasterLayout />}>
                        
                        
                        <Route path="usuarios" element={<Outlet />}>
                            <Route index element={<UsersListPage />} />
                            <Route path=":id" element={<UsersPage />} />
                            <Route path="add" element={<UsersPage />} />
                        </Route>
                        <Route path="clientes" element={<Outlet />}>
                            <Route index element={<ClientesListPage />} />
                            <Route path=":id" element={<ClientesPage />} />
                            <Route path="add" element={<ClientesPage />} />
                        </Route>

                        <Route path="produtos" element={<Outlet />}>
                            <Route index element={<ProdutosListPage />} />
                            <Route path=":id" element={<ProdutosPage />} />
                            <Route path="add" element={<ProdutosPage />} />
                        </Route>

                        <Route path="pedidos" element={<Outlet />}>
                            <Route index element={<PedidosListPage />} />
                            <Route path=":id" element={<PedidosPage />} />
                            <Route path="add" element={<PedidosPage />} />
                        </Route>
                        
                        <Route path="relatorio" element={<Outlet />}>
                            <Route index element={<RelatorioPage />} />
                        </Route>
                        <Route path="dashboard" element={<Outlet />}>
                            <Route index element={<DashboardPage />} />
                        </Route>

                        <Route path="perfil" index element={<ViewProfilePage />} />
                    </Route>

               
                </Route>

                <Route path="terms-condition" element={<TermsConditionPage />} />
                <Route path="*" element={<ErrorPage />} />
            </Routes>
        </>
    );
}

export default App;
